module.exports = __webpack_public_path__ + "static/media/detailed.e9ab79f3.jpg";